// Shared UI constants extracted from app.jsx (decomposition). Pure data
// used across multiple views — imported by app.jsx and by extracted
// components so both resolve the same source.

// Incident report categories → emoji label. Used by IncidentReportView,
// IncidentTriageView, and the incident settings picker.
export const INCIDENT_CATEGORY_LABELS = {
  injury:             '🩹 Injury',
  police_security:    '🚓 Police / security',
  broken_equipment:   '🛠 Broken equipment',
  customer_complaint: '🗣 Customer complaint',
  theft:              '🚨 Theft',
  other:              '📌 Other',
};

// Event sales-impact label + color chip. Used by EventsSettingsView and the
// schedule/build event surfaces.
export const EVENT_SALES_LABEL = {
  increase: '↑ Increases sales', decrease: '↓ Decreases sales',
  neutral:  'Neutral',           unknown:  'Unknown impact',
};
export const EVENT_SALES_COLOR = {
  increase: { bg: '#e6f4ea', fg: '#1e7d3a', bd: '#c8e2c8' },
  decrease: { bg: '#fef2f2', fg: '#a13030', bd: '#fecaca' },
  neutral:  { bg: '#fafafa', fg: '#666',     bd: '#e0e0e0' },
  unknown:  { bg: '#fafafa', fg: '#888',     bd: '#e0e0e0' },
};

// Compliance reminder category → icon / label. Used by the compliance
// create modal, reminder-detail modal, and ComplianceView.
export const CATEGORY_ICON = { license:'📋', tax:'💰', insurance:'🛡️', permit:'📝', lease:'🏢', other:'📌' };
export const CATEGORY_LABEL = { license:'License', tax:'Tax', insurance:'Insurance', permit:'Permit', lease:'Lease', other:'Other' };

// Task-manager role targets + weekday chips. Used by TaskManagerModal.
export const ROLES = ['Barista', 'Shift Lead', 'Opening Staff', 'Closing Staff', 'Kitchen', 'Manager', 'Any'];
export const DAYS_OF_WEEK = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];

// Scorecard / status tone palette (bar + bg + text per severity). Used by the
// reports dashboard cards, phase strip, shift rows, and clock-alert banners.
export const FLAG_TONE = {
  green:  { bar: '#2e7d32', bg: '#e8f5e9', text: '#2e7d32' },
  yellow: { bar: '#f9a825', bg: '#fff8e1', text: '#a16207' },
  red:    { bar: '#c62828', bg: '#ffebee', text: '#c62828' },
  blue:   { bar: '#1565c0', bg: '#e3f2fd', text: '#1565c0' },
  gray:   { bar: '#9e9e9e', bg: '#f5f5f5', text: '#616161' },
};
// Day-part glyphs for the phase strip.
export const PHASE_GLYPH = { sunrise: '☀', zap: '⚡', sunset: '🌅', moon: '🌙' };
// Minutes of slack before a clock-in/out is flagged as an issue.
export const ISSUE_TOL_MIN = 5;
